// extracted by mini-css-extract-plugin
module.exports = {"content":"content___sRNYe","notFound":"notFound___14NH3","text":"text___l5dfi","customizedDark":"customizedDark___2xets","customizedLight":"customizedLight___1GIyV"};